// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    forresterLink: {
        href: "https://monday.com/lp/motorola-forrester-report",
        target: "_self"
    },
    forresterLinkText: "Learn more",
    forresterText: "Motorola achieved 346% ROI according to Forrester’s Total Economic Impact™ research.",
    g2Text: "Leader in the <br /> G2 Enterprise Grid® Report Spring 2025",
    gartnerLinkLink: {
        href: "https://monday.com/w/gartner-mq/leader-3x",
        target: "_self"
    },
    gartnerLinkText: "Learn more",
    gartnerText: "The only Leader in 3 Work Management Gartner® Magic Quadrant™ reports.",
    title: "A leader you can trust"
};
